/* ============================================================
   PREMIUM SEARCH + MEGA MENU
   · Three-column predictive overlay (suggestions / products / guides)
   · AI intent expansion from the merchant's keyword map
   · Rotating animated placeholder
   · Full keyboard control, add-to-bag straight from results
   · Mega menu open/close with shared scrim
   Dependency-free. Every module no-ops when its markup is absent.
   ============================================================ */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m];
    });
  }
  function escRe(s) { return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function mark(text, q) {
    var t = esc(text);
    if (!q) return t;
    var terms = q.trim().split(/\s+/).filter(function (w) { return w.length > 1; }).map(escRe);
    if (!terms.length) return t;
    try { return t.replace(new RegExp('(' + terms.join('|') + ')', 'gi'), '<mark>$1</mark>'); }
    catch (e) { return t; }
  }
  function store(k, v) {
    try {
      if (v === undefined) { var r = localStorage.getItem(k); return r ? JSON.parse(r) : null; }
      localStorage.setItem(k, JSON.stringify(v)); return v;
    } catch (e) { return null; }
  }
  function money(cents) {
    if (window.PremiumTheme && window.PremiumTheme.money) return window.PremiumTheme.money(cents);
    return (cents / 100).toFixed(2);
  }
  function toast(msg) {
    if (window.PremiumTheme && window.PremiumTheme.toast) window.PremiumTheme.toast(msg);
  }

  var ICON = {
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>',
    spark: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l1.9 5.6L19.5 9.5 13.9 11.4 12 17l-1.9-5.6L4.5 9.5l5.6-1.9L12 2z"/></svg>'
  };

  var RECENT_KEY = 'pm_recent_searches_v1';
  function recent(add) {
    var list = store(RECENT_KEY) || [];
    if (add) {
      list = [add].concat(list.filter(function (x) { return x.toLowerCase() !== add.toLowerCase(); })).slice(0, 6);
      store(RECENT_KEY, list);
    }
    return list;
  }

  /* ============================================================
     AI intent expansion — client side, no latency cost
     ============================================================ */
  function aiSuggest(query, cfg, resultTitles) {
    var q = (query || '').toLowerCase().trim();
    if (q.length < 2) return [];
    var map = (cfg && cfg.intentMap) || {};
    var pool = {};

    Object.keys(map).forEach(function (trigger) {
      if (q.indexOf(trigger.toLowerCase()) !== -1) {
        (map[trigger] || []).forEach(function (s) { pool[s] = (pool[s] || 0) + 3; });
      }
    });

    var tokens = q.split(/\s+/).filter(function (t) { return t.length > 2; });
    Object.keys(map).forEach(function (trigger) {
      var tl = trigger.toLowerCase();
      tokens.forEach(function (t) {
        if (tl.indexOf(t) !== -1 || t.indexOf(tl) !== -1) {
          (map[trigger] || []).forEach(function (s) { pool[s] = (pool[s] || 0) + 1; });
        }
      });
    });

    // Narrow the query using vocabulary that actually came back
    (resultTitles || []).slice(0, 6).forEach(function (title) {
      String(title).toLowerCase().split(/[^a-z0-9؀-ۿ]+/).forEach(function (w) {
        if (w.length < 4 || q.indexOf(w) !== -1) return;
        pool[q + ' ' + w] = (pool[q + ' ' + w] || 0) + 0.6;
      });
    });

    return Object.keys(pool)
      .filter(function (s) { return s.toLowerCase() !== q; })
      .sort(function (a, b) { return pool[b] - pool[a]; })
      .slice(0, (cfg && cfg.aiLimit) || 4);
  }

  /* ============================================================
     Predictive search overlay
     ============================================================ */
  function initSearch() {
    var root = $('[data-pm-psearch]');
    if (!root) return;

    var cfg = {};
    try { cfg = JSON.parse(root.dataset.pmConfig || '{}'); } catch (e) {}

    var input = $('[data-pm-psearch-input]', root);
    var suggestEl = $('[data-pm-psearch-suggestions]', root);
    var recentEl = $('[data-pm-psearch-recent]', root);
    var recentTitle = $('[data-pm-psearch-recent-title]', root);
    var productsEl = $('[data-pm-psearch-products]', root);
    var countEl = $('[data-pm-psearch-count]', root);
    var allLink = $('[data-pm-psearch-all]', root);
    var clearBtn = $('[data-pm-psearch-clear]', root);
    var scrim = $('[data-pm-scrim]');
    var trigger = $('[data-pm-search-open]');
    if (!input) return;

    var controller = null;
    var cache = {};
    var activeIndex = -1;
    var release = null;
    var ghostTimer = null;

    function searchUrl(q) {
      var base = (window.routes && window.routes.search_url) || '/search';
      return base + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
    }

    /* ---------- rotating placeholder ---------- */
    var words = (cfg.keywords || []).slice();
    function startGhost() {
      if (REDUCED || !words.length) return;
      var i = 0;
      var base = input.getAttribute('placeholder') || '';
      ghostTimer = setInterval(function () {
        if (document.hidden || input.value) return;
        input.setAttribute('placeholder', words[i % words.length]);
        i++;
      }, 2600);
      input.dataset.basePlaceholder = base;
    }
    function stopGhost() {
      if (ghostTimer) { clearInterval(ghostTimer); ghostTimer = null; }
      if (input.dataset.basePlaceholder) input.setAttribute('placeholder', input.dataset.basePlaceholder);
    }

    /* ---------- open / close ---------- */
    var opener = null;
    function open() {
      opener = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      if (scrim) scrim.classList.add('is-open');
      if (trigger) { trigger.classList.add('is-active'); trigger.setAttribute('aria-expanded', 'true'); }
      if (window.PremiumTheme) {
        window.PremiumTheme.lockScroll(true);
        release = window.PremiumTheme.trapFocus(root);
      }
      startGhost();
      render();
      setTimeout(function () { input.focus(); }, 60);
    }
    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      if (scrim) scrim.classList.remove('is-open');
      if (trigger) { trigger.classList.remove('is-active'); trigger.setAttribute('aria-expanded', 'false'); }
      if (window.PremiumTheme) window.PremiumTheme.lockScroll(false);
      if (release) { release(); release = null; }
      stopGhost();
      activeIndex = -1;
      if (opener && opener.focus) opener.focus();
    }
    root.pmClose = close;

    $$('[data-pm-search-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    $$('[data-pm-search-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    if (scrim) scrim.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) { close(); return; }
      if (e.key === '/' && !root.classList.contains('is-open')) {
        var tag = document.activeElement && document.activeElement.tagName;
        if (/^(INPUT|TEXTAREA|SELECT)$/.test(tag) || document.activeElement.isContentEditable) return;
        e.preventDefault(); open();
      }
    });

    /* ---------- renderers ---------- */
    function renderSuggestions(list, q) {
      if (!suggestEl) return;
      if (!list.length) { suggestEl.innerHTML = ''; return; }
      suggestEl.innerHTML = list.map(function (s) {
        return '<a class="pm-psugg" data-pm-opt data-pm-term="' + esc(s) + '" href="' + searchUrl(s) + '">' +
          ICON.search + '<span>' + mark(s, q) + '</span></a>';
      }).join('');
    }

    function renderRecent() {
      if (!recentEl) return;
      var list = recent();
      if (recentTitle) recentTitle.hidden = list.length === 0;
      recentEl.innerHTML = list.map(function (t) {
        return '<a href="' + searchUrl(t) + '">' + esc(t) + '</a>';
      }).join('');
    }

    function renderProducts(list, q) {
      if (!productsEl) return;
      if (countEl) countEl.textContent = list.length ? (list.length + ' ' + (list.length === 1 ? 'result' : 'results')) : '';

      if (!list.length) {
        productsEl.innerHTML = q
          ? '<div class="pm-psearch__empty"><p style="margin:0 0 .6rem;font-size:1.5rem;color:var(--pm-ink)">' +
            esc((cfg.i18nNoResults || 'No matches for “{q}”').replace('{q}', q)) + '</p>' +
            '<p style="margin:0;font-size:1.35rem">' + esc(cfg.i18nNoResultsHint || '') + '</p></div>'
          : '';
        return;
      }

      productsEl.innerHTML = list.map(function (p) {
        var img = p.featured_image && p.featured_image.url
          ? '<img src="' + esc(p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2')) +
            '" alt="" width="200" height="250" loading="lazy" decoding="async">'
          : '';
        var meta = [];
        if (p.vendor) meta.push(esc(p.vendor));
        if (p.type) meta.push(esc(p.type));
        var vid = (p.variants && p.variants[0] && p.variants[0].id) || null;
        var avail = p.available !== false;

        return '<div class="pm-pres">' +
          '<a class="pm-pres__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
          '<div>' +
            (p.type ? '<span class="pm-pres__tag">' + esc(p.type) + '</span>' : '') +
            '<a class="pm-pres__t" data-pm-opt href="' + esc(p.url) + '" style="display:block;text-decoration:none">' +
              mark(p.title, q) + '</a>' +
            (meta.length ? '<p class="pm-pres__meta">' + meta.map(function (m) { return '<span>' + m + '</span>'; }).join('') + '</p>' : '') +
            '<p class="pm-pres__price">' + money(p.price) + '</p>' +
            (vid && avail
              ? '<button type="button" class="pm-btn pm-btn--green pm-btn--sm pm-btn--block pm-btn--square" data-pm-quick-add="' + vid + '">' +
                esc(cfg.i18nAddToBag || 'Add to bag') + '</button>'
              : '<button type="button" class="pm-btn pm-btn--sm pm-btn--block pm-btn--square" disabled style="opacity:.5">' +
                esc(cfg.i18nSoldOut || 'Sold out') + '</button>') +
          '</div>' +
        '</div>';
      }).join('');
    }

    function render(data, q) {
      q = q || '';
      renderRecent();
      if (allLink) allLink.href = q ? searchUrl(q) : ((window.routes && window.routes.search_url) || '/search');

      if (!q) {
        renderSuggestions(cfg.trending || [], '');
        renderProducts([], '');
        return;
      }
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [];
      var queries = (r.queries || []).map(function (x) { return x.text; });
      var ai = aiSuggest(q, cfg, products.map(function (p) { return p.title; }));

      var seen = {};
      var suggestions = [q].concat(queries, ai).filter(function (s) {
        if (!s) return false;
        var k = s.toLowerCase();
        if (seen[k]) return false;
        seen[k] = 1;
        return true;
      }).slice(0, 5);

      renderSuggestions(suggestions, q);
      renderProducts(products.slice(0, cfg.limit || 3), q);
    }

    /* ---------- fetch ---------- */
    function fetchResults(q) {
      if (cache[q]) { render(cache[q], q); return; }
      if (controller) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;

      var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
      var url = base + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,query' +
        '&resources[limit]=' + (cfg.limit || 3) +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag';

      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
        .then(function (data) {
          cache[q] = data;
          if (input.value.trim() === q) render(data, q);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          render(null, q);
        });
    }

    var debounced = (function () {
      var t;
      return function (q) { clearTimeout(t); t = setTimeout(function () { fetchResults(q); }, 200); };
    })();

    input.addEventListener('input', function () {
      var q = input.value.trim();
      activeIndex = -1;
      if (q.length < 2) { render(null, ''); return; }
      debounced(q);
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        input.focus();
        render(null, '');
      });
    }

    var form = input.closest('form');
    if (form) {
      form.addEventListener('submit', function () {
        var q = input.value.trim();
        if (q) recent(q);
      });
    }

    /* ---------- keyboard navigation ---------- */
    function options() { return $$('[data-pm-opt]', root); }
    function setActive(i) {
      var list = options();
      if (!list.length) return;
      if (i < 0) i = list.length - 1;
      if (i >= list.length) i = 0;
      list.forEach(function (el, n) {
        el.setAttribute('aria-selected', n === i ? 'true' : 'false');
        if (n === i && el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
      });
      activeIndex = i;
    }
    input.addEventListener('keydown', function (e) {
      var list = options();
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); setActive(activeIndex + 1); }
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); setActive(activeIndex - 1); }
      else if (e.key === 'Enter') {
        var q = input.value.trim();
        if (activeIndex > -1 && list[activeIndex]) {
          e.preventDefault();
          if (q) recent(q);
          list[activeIndex].click();
        } else if (q) recent(q);
      }
    });

    /* ---------- add to bag from results ---------- */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-pm-quick-add]');
      if (!btn) return;
      e.preventDefault();
      addToCart(btn.dataset.pmQuickAdd, 1, btn);
    });

    render(null, '');
  }

  /* ============================================================
     Shared add-to-cart
     ============================================================ */
  function addToCart(variantId, qty, btn) {
    if (!variantId) return;
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }

    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: parseInt(qty, 10) || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.data && res.data.description) || 'Cart error');
        toast('Added to your bag');
        refreshCartCount();
        document.dispatchEvent(new CustomEvent('pm:cart:updated'));
      })
      .catch(function (err) { toast(err.message || 'Something went wrong'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
  }
  window.PremiumTheme = window.PremiumTheme || {};
  window.PremiumTheme.addToCart = addToCart;

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-pm-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () {});
  }

  /* ============================================================
     Mega menu
     ============================================================ */
  function initMega() {
    var items = $$('.pm-nav__item--mega');
    if (!items.length) return;
    var scrim = $('[data-pm-scrim]');
    var openItem = null;
    var hoverTimer = null;

    function openMega(item) {
      if (openItem === item) return;
      closeMega();
      openItem = item;
      item.classList.add('is-open');
      var link = $('.pm-nav__link', item);
      if (link) link.setAttribute('aria-expanded', 'true');
      if (scrim) scrim.classList.add('is-open');
    }
    function closeMega() {
      if (!openItem) return;
      openItem.classList.remove('is-open');
      var link = $('.pm-nav__link', openItem);
      if (link) link.setAttribute('aria-expanded', 'false');
      openItem = null;
      var search = $('[data-pm-psearch]');
      if (scrim && !(search && search.classList.contains('is-open'))) scrim.classList.remove('is-open');
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        clearTimeout(hoverTimer);
        openMega(item);
      });
      item.addEventListener('mouseleave', function () {
        hoverTimer = setTimeout(closeMega, 140);
      });
      item.addEventListener('focusin', function () { openMega(item); });

      var closeBtn = $('[data-pm-mega-close]', item);
      if (closeBtn) closeBtn.addEventListener('click', function (e) { e.preventDefault(); closeMega(); });

      // Keyboard: Enter/Space on the top link toggles instead of navigating
      var link = $('.pm-nav__link', item);
      if (link) {
        link.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            if (openItem !== item) { e.preventDefault(); openMega(item); }
          }
        });
      }
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMega(); });
    if (scrim) scrim.addEventListener('click', closeMega);
  }

  /* ============================================================
     Quick-add forms inside the mega menu
     ============================================================ */
  function initQuickForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('[data-pm-quick-form]');
      if (!form) return;
      e.preventDefault();
      var id = form.querySelector('input[name="id"]');
      var qty = form.querySelector('input[name="quantity"]');
      var btn = form.querySelector('button[type="submit"]');
      addToCart(id && id.value, qty ? qty.value : 1, btn);
    });

    // Mini quantity steppers
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.pm-miniqty [data-pm-qty]');
      if (!btn) return;
      var wrap = btn.closest('.pm-miniqty');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var min = parseInt(input.min || '1', 10) || 1;
      var val = parseInt(input.value || min, 10) || min;
      val += (btn.dataset.pmQty === 'up' ? 1 : -1);
      input.value = Math.max(min, val);
    });
  }

  function boot() {
    initSearch();
    initMega();
    initQuickForms();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
